import { ComponentTwinsGroupsApi } from '@evimo/client/apis';
import { createApiConfiguration } from '~/app/lib/api-config';

const config = createApiConfiguration();

export const componentTwinsGroupsApi = new ComponentTwinsGroupsApi(config);

export const componentTwinsGroupRequestInit = {
  credentials: 'include' as const,
};
